import { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import { Button } from "@mui/material";

export const CompletePopup = (props: any) => {
  console.log(props.responsePopup);

  return (
    <Dialog
      PaperProps={{
        style: { borderRadius: 0, width: "600px" },
      }}
      open={props.responsePopup}
      maxWidth={"lg"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent className="p-4">
        <div style={{ fontSize: "23px", textAlign: "center" }}>
          {props?.data?.data?.length != 0 ? props?.data?.data?.message : ""}
        </div>

        <div className="dialog_footer p-0">
          <Button
            disableRipple
            onClick={() => {
              props.setCompletePopup(false);
            }}
            className="common_btn mt-5"
            style={{ width: "130px" }}
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CompletePopup;
